import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';

const NON_SCORABLE_TYPES = ['Expert opinion', 'Editorial', 'Letter', 'Commentary'];
const EVIDENCE_SYNTHESIS_TYPES = ['Meta-analysis', 'Systematic review', 'Scoping review', 'Narrative review', 'Critical appraisal review'];

export const ScoreBreakdownBar = ({ article }) => {
  const isCaseReport = article.normalized_study_type === 'Case report' || article.normalized_study_type === 'Case series';
  const isNonScorable = NON_SCORABLE_TYPES.includes(article.normalized_study_type);
  const isEvidenceSynthesis = EVIDENCE_SYNTHESIS_TYPES.includes(article.normalized_study_type);

  if (!article.impact_index || isNonScorable) return null;

  const maxEvidence = (isCaseReport || isEvidenceSynthesis) ? 35 : 70;
  const evidenceLabel = isEvidenceSynthesis ? 'Evidence Synthesis Score' : (isCaseReport ? 'Clinical Value Score' : 'Methodology Score');
  const barColor = isEvidenceSynthesis ? 'bg-teal-100' : 'bg-green-100';

  return (
    <Card className="mb-8" data-testid="score-breakdown-card">
      <CardHeader>
        <CardTitle>Score Breakdown</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <div className="flex justify-between text-sm mb-2">
              <span className="font-medium">{evidenceLabel}</span>
              <span>{article.methodology_score ? article.methodology_score.toFixed(1) : 0} / {maxEvidence}</span>
            </div>
            <Progress value={(article.methodology_score || 0) / maxEvidence * 100} className={`h-3 ${barColor}`} data-testid="methodology-progress" />
          </div>
          <div>
            <div className="flex justify-between text-sm mb-2">
              <span className="font-medium">Visibility Score</span>
              <span>{article.visibility_score ? article.visibility_score.toFixed(1) : 0} / 30</span>
            </div>
            <Progress value={(article.visibility_score || 0) / 30 * 100} className="h-3 bg-purple-100" data-testid="visibility-progress" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
